import React, { Component } from 'react';
import JsonTree from 'react-json-tree';
import _ from 'lodash';
import { inspect } from 'util';
import {
  Modal, Tabs,
} from 'antd';
import { HelpText } from '../../views/typography';

const jsonTheme = {
  scheme: 'eighties',
    author: 'chris kempson (http://chriskempson.com)',
    base00: '#2d2d2d',
    base01: '#393939',
    base02: '#515151',
    base03: '#747369',
    base04: '#a09f93',
    base05: '#d3d0c8',
    base06: '#e8e6df',
    base07: '#f2f0ec',
    base08: '#f2777a',
    base09: '#f99157',
    base0A: '#ffcc66',
    base0B: '#99cc99',
    base0C: '#66cccc',
    base0D: '#6699cc',
    base0E: '#cc99cc',
    base0F: '#d27b53'
};

const { TabPane } = Tabs;

export default class ObjDialog extends Component {
  render() {
    const {
      title = 'Object', info = '', value, showDialog, onClose,
    } = this.props;

    console.log('ObjDialog:', title, value);
    const isObject = _.isObject(value);
    let code = '';

    if (isObject) {
      try {
        code = JSON.stringify(value);
      } catch (err) {
        code = inspect(value);
      }
    } else {
      code = inspect(value);
    }

    return (
      <Modal
        width={650}
        title={title}
        visible={showDialog}
        onOk={onClose}
        onCancel={onClose}
        cancelText=""
        destroyOnClose
      >
        {isObject ? (
          <Tabs defaultActiveKey="object">
            <TabPane tab="Data" key="object">
              <JsonTree data={value} theme={jsonTheme} />
            </TabPane>
            <TabPane tab="Raw Text" key="2">
              <code>
                {code}
              </code>
            </TabPane>
          </Tabs>
        ) : <code>{code}</code>}
      </Modal>
    );
  }
}
